// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_loginpage__soiCD{
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: url('../images/loginbg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; */
}
.login_loginpage__soiCD  .login_customcontainer__0ev2O{
    max-width:90%;
}

.login_logincard__pI47B{
    background: var(--whtclr);
    border-radius: 10px;
    padding: 2vh;
    border: 1px solid #ffffff26;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    /* border: 1px solid var(--cardbg); */
}
.login_logincard__pI47B .login_logoimg__s-oly{
    width: 15vh;
    height: 10vh;
    object-fit: contain;

}
.login_logincard__pI47B .login_formsec__EZxrC label{
    color: var(--themecolor);
    font-size: 1.8vh;
    font-weight: 500;
    margin-bottom: 1vh;
}
.login_loginpage__soiCD input{
    background: transparent !important;
    border: 0.1vh solid var(--blackclr) !important;
    color: var(--blackclr) !important;
    font-size: 2vh;
    padding: 1vh ;
    border-radius: 0.2vh;
}
.login_loginpage__soiCD input:focus{
    box-shadow: none;
    outline: 0;
}
.login_loginpage__soiCD input::placeholder{
    color: var(--blackclr);
    opacity: 0.5;
}
.login_loginpage__soiCD input:-webkit-autofill,
.login_loginpage__soiCD input:-webkit-autofill:hover, 
.login_loginpage__soiCD input:-webkit-autofill:focus{
  border: 1px solid var(--themecolor2);
  -webkit-text-fill-color: var(--blackclr);
  /* -webkit-box-shadow: 0 0 0px 1000px #000 inset; */
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}
.login_loginpage__soiCD  .login_forgottext__7nxnm{
    color: var(--themecolor) ;
    font-size: 2.2vh; 
}
.login_loginpage__soiCD  .login_forgottext__7nxnm:hover{
    color: var(--themehover);
    cursor: pointer;
}
.login_loginpage__soiCD  .login_eyesec__1R-Sp{
    background: var(--themecolor);
    border: 1px solid var(--themecolor2);
    padding: 1vh;
}
.login_loginpage__soiCD  .login_eyesec__1R-Sp svg {
    fill: var(--whtclr);
    cursor: pointer;
    font-size: 2.2vh;

}
.login_loginpage__soiCD .login_headtext__9Tn9G{
    color: var(--themecolor);
    font-size: 3vh;
    font-weight: 600;
    text-align: center;
    margin-bottom: 2vh;
}
.login_otpinputsec__TzKTA input{
    width: 35px !important;
}
.login_mbspace__YDILg{
    margin-bottom: 2vh;
}
.login_mbtopspace__HiVhW{
    margin-top: 2vh;
}
.login_colspace__ZZ2Bq{
    padding: 0vh 2vh;
}
.login_logbtn__3uhf1{
    font-size: 2.2vh;
    padding: 1vh 3vh;
    width: fit-content;
}
.login_otpinput__Rwhp9 input{
    width: 5vh !important;
}

.login_error_msg__pAlLJ{
    color:#f00;
}
.login_otpss__5HTAn div{
   justify-content: center !important;
   gap: 10px;
}
.login_sendotp__ymS1D{
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    width: fit-content;
    margin: auto;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.login_sendotp__ymS1D input{
    color: #000;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/login.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;;;kCAG8B;AAClC;AACA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,uCAAuC;IACvC,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;;AAEvB;AACA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kCAAkC;IAClC,8CAA8C;IAC9C,iCAAiC;IACjC,cAAc;IACd,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,YAAY;AAChB;AACA;;;EAGE,oCAAoC;EACpC,wCAAwC;EACxC,mDAAmD;EACnD,yDAAiD;EAAjD,iDAAiD;AACnD;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,wBAAwB;IACxB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;AACA;GACG,kCAAkC;GAClC,SAAS;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf","sourcesContent":[".loginpage{\n    min-height: 100vh;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* background: url('../images/loginbg.png');\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center; */\n}\n.loginpage  .customcontainer{\n    max-width:90%;\n}\n\n.logincard{\n    background: var(--whtclr);\n    border-radius: 10px;\n    padding: 2vh;\n    border: 1px solid #ffffff26;\n    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n    /* border: 1px solid var(--cardbg); */\n}\n.logincard .logoimg{\n    width: 15vh;\n    height: 10vh;\n    object-fit: contain;\n\n}\n.logincard .formsec label{\n    color: var(--themecolor);\n    font-size: 1.8vh;\n    font-weight: 500;\n    margin-bottom: 1vh;\n}\n.loginpage input{\n    background: transparent !important;\n    border: 0.1vh solid var(--blackclr) !important;\n    color: var(--blackclr) !important;\n    font-size: 2vh;\n    padding: 1vh ;\n    border-radius: 0.2vh;\n}\n.loginpage input:focus{\n    box-shadow: none;\n    outline: 0;\n}\n.loginpage input::placeholder{\n    color: var(--blackclr);\n    opacity: 0.5;\n}\n.loginpage input:-webkit-autofill,\n.loginpage input:-webkit-autofill:hover, \n.loginpage input:-webkit-autofill:focus{\n  border: 1px solid var(--themecolor2);\n  -webkit-text-fill-color: var(--blackclr);\n  /* -webkit-box-shadow: 0 0 0px 1000px #000 inset; */\n  transition: background-color 5000s ease-in-out 0s;\n}\n.loginpage  .forgottext{\n    color: var(--themecolor) ;\n    font-size: 2.2vh; \n}\n.loginpage  .forgottext:hover{\n    color: var(--themehover);\n    cursor: pointer;\n}\n.loginpage  .eyesec{\n    background: var(--themecolor);\n    border: 1px solid var(--themecolor2);\n    padding: 1vh;\n}\n.loginpage  .eyesec svg {\n    fill: var(--whtclr);\n    cursor: pointer;\n    font-size: 2.2vh;\n\n}\n.loginpage .headtext{\n    color: var(--themecolor);\n    font-size: 3vh;\n    font-weight: 600;\n    text-align: center;\n    margin-bottom: 2vh;\n}\n.otpinputsec input{\n    width: 35px !important;\n}\n.mbspace{\n    margin-bottom: 2vh;\n}\n.mbtopspace{\n    margin-top: 2vh;\n}\n.colspace{\n    padding: 0vh 2vh;\n}\n.logbtn{\n    font-size: 2.2vh;\n    padding: 1vh 3vh;\n    width: fit-content;\n}\n.otpinput input{\n    width: 5vh !important;\n}\n\n.error_msg{\n    color:#f00;\n}\n.otpss div{\n   justify-content: center !important;\n   gap: 10px;\n}\n.sendotp{\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    width: fit-content;\n    margin: auto;\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.sendotp input{\n    color: #000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginpage": `login_loginpage__soiCD`,
	"customcontainer": `login_customcontainer__0ev2O`,
	"logincard": `login_logincard__pI47B`,
	"logoimg": `login_logoimg__s-oly`,
	"formsec": `login_formsec__EZxrC`,
	"forgottext": `login_forgottext__7nxnm`,
	"eyesec": `login_eyesec__1R-Sp`,
	"headtext": `login_headtext__9Tn9G`,
	"otpinputsec": `login_otpinputsec__TzKTA`,
	"mbspace": `login_mbspace__YDILg`,
	"mbtopspace": `login_mbtopspace__HiVhW`,
	"colspace": `login_colspace__ZZ2Bq`,
	"logbtn": `login_logbtn__3uhf1`,
	"otpinput": `login_otpinput__Rwhp9`,
	"error_msg": `login_error_msg__pAlLJ`,
	"otpss": `login_otpss__5HTAn`,
	"sendotp": `login_sendotp__ymS1D`
};
export default ___CSS_LOADER_EXPORT___;
